/* eslint-disable import/prefer-default-export */

const delay = async (time: number) => {
  await new Promise((resolve) => { setTimeout(resolve, time); });
};

export {
  delay,
};
